import { ScrollableArea } from '@approvalmax/ui';
import { PriceCheckIndicator } from 'modules/request';
import styled from 'styled-components';

import { LineItemsTable } from '../../../components/lineItemsSection/LineItemsTable/LineItemsTable';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    position: relative;
    height: 100%;
    width: 100%;
`;

export const Toolbar = styled.div`
    flex: none;
    padding: 25px 80px 30px 80px;
    border-bottom: 1px solid #cacccd;
    display: flex;
    align-items: center;
`;

export const ToolbarText = styled.div`
    flex: 1;
    font-weight: 600;
    font-size: 20px;
    color: #333;
    text-transform: uppercase;
`;

export const Content = styled(ScrollableArea)`
    flex: 1;
    overflow: auto;
`;

export const ContentInner = styled.div`
    padding-bottom: 40px;
    display: flex;
    flex-flow: column;
`;

export const StyledLineItemsTable = styled(LineItemsTable)`
    overflow: auto;

    & .reqf-line-items-table-row__row-body {
        overflow: initial;
    }

    & .reqf-line-items-table__add-line-button:hover {
        border-color: transparent;
    }
`;

export const StyledBillPaymentLineItemsTable = styled(LineItemsTable)`
    overflow: auto;

    & .reqf-line-items-table-header {
        padding-left: 0;
    }

    & .reqf-line-items-table-row__row-body {
        overflow: initial;
    }

    & .reqf-line-items-table-row__row-before {
        display: none;
    }

    & .reqf-line-items-table__add-line-button:hover {
        border-color: transparent;
    }
`;

export const DropdownEditorContainer = styled.div`
    margin: -3px;
`;

export const StyledPriceCheckIndicator = styled(PriceCheckIndicator)`
    && {
        position: relative;
        width: calc(100% + 20px);
        height: calc(100% + 30px);
        margin: -15px -10px;
        padding: 15px 10px;
    }
`;

export const GroupActions = styled.div`
    position: absolute;
    background: #fff;
    display: flex;
    align-items: flex-end;
    gap: 20px;
`;

export const SectionHeader = styled.div`
    padding: 0 60px;
    display: flex;
    align-items: center;
    position: relative;
`;
